import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import Comments from '../cart/Comments';
import PONumber from '../cart/PONumber';
import Loading from '../Loading';
import MUIModal from '../shared/MUIModal';
import MUIModalButtonStyles from '../shared/MUIStyles/MUIModalButtonStyles';
import { Button } from '@mui/material';
import { validatePONumber } from "../../helpers/InputValidationHelper";
export default function ConvertToOrderModal(props) {
    const { comments, poNumber, poNumberUpdated, commentsUpdated, requiredPO, maxPOLength, fetching, localized, show, onHide, callback, converting } = props;
    const [submitAttempted, setSubmitAttempted] = useState(false);
    useEffect(() => {
        if (show) setSubmitAttempted(false);
    }, [show]);


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            const tag = e.target?.tagName?.toLowerCase();
            if (tag === "textarea") return;
            e.preventDefault();
            e.stopPropagation();
            handleConvertClick();
        }
    };

    const handleConvertClick = () => {
        setSubmitAttempted(true);
        const validation = validatePONumber(requiredPO, poNumber, localized, maxPOLength);
        if (!validation.isValid) { return; }

        callback?.();
    };


    return (
        <div>
            <MUIModal
                open={show}
                onClose={onHide}
                closeLabel={localized.Cancel}
                title={localized.ConvertToOrder}
                maxWidth="md"
                showDefaultButtons={false}
                customActions={
                    <>
                        <Button
                            type="button"
                            onClick={onHide}
                            sx={MUIModalButtonStyles}
                        >
                            {localized.Cancel}
                        </Button>
                        <Button
                            type="button"
                            onClick={handleConvertClick}
                            sx={MUIModalButtonStyles}
                            disabled={converting || fetching}
                        >
                            {localized.Convert}
                        </Button>
                    </>
                }
            >
                <div onKeyDown={handleKeyDown}>
                <Container>
                    <Row>
                        {
                            fetching &&
                            <Loading type="brand" />
                        }
                    </Row>
                    {!fetching && (
                        <>
                            <Row style={{ paddingBottom: '2rem' }}>
                                <Col xs={12} md={3} className="label">
                                    {localized.PONumber}
                                </Col>
                                <Col xs={12} md={9}>
                                    <PONumber isRequired={requiredPO} poNumberUpdated={poNumberUpdated} poNumber={poNumber} maxLength={maxPOLength} localized={localized} forceValidate={submitAttempted} />
                                </Col>
                            </Row>
                            <Row style={{ paddingBottom: '2rem' }}>
                                <Col xs={12} md={3} className="label">
                                    {localized.Comments}
                                </Col>
                                <Col xs={12} md={9}>
                                    <Comments commentsUpdated={commentsUpdated} comments={comments} />
                                </Col>
                            </Row>
                        </>
                    )}
                </Container>
                </div>
            </MUIModal>
        </div>
    )
};

ConvertToOrderModal.propTypes = {
    comments: PropTypes.string,
    commentsUpdated: PropTypes.func,
    poNumber: PropTypes.string,
    poNumberUpdated: PropTypes.func,
    requiredPO: PropTypes.bool,
    maxPOLength: PropTypes.number,
    fetching: PropTypes.bool,
    localized: PropTypes.object,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    callback: PropTypes.func,
    converting: PropTypes.bool,

};